import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'gbReplaceChars',
})
export class GbReplaceCharsPipe implements PipeTransform {
  constructor() {}

  public transform(value: string | undefined, searchValue: string, replaceValue: string): string {
    if (!value) return ''
    return value.replaceAll(searchValue, replaceValue)
  }
}
